import type {Record, LabeledIdentified} from 'typings/portaro.be.types'
import {transferify, unRestangularize} from 'shared/utils/data-service-utils';
import type {Citation, CitationCitacePro} from './types';


export class CitationDataService {
    public static serviceName = 'citationDataService';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {}

    @unRestangularize()
    public async getCitation(record: Record, style?: LabeledIdentified<string>): Promise<Citation | CitationCitacePro> {
        return this.Restangular
            .one('records', record.id)
            .one('citation')
            .get(transferify({style}))
    }
}